import React, { useEffect, useState } from "react";
import { Modal, Row, Col } from "antd";

import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import RenderDesingProcessData from "../../components/render-desing-process-data";

import { HeaderOptions } from "./styles";

import moment from "moment";

// Hooks
import useProcessDesings from "../../hooks/useProcessDesings";

//import multilanguage library
import { useTranslation } from "react-i18next";

const ModalDesingProcess = ({ visible, handleVisible, article, setLink }) => {
  const [listDesings, setListDesings] = useState(null);
  const [selectedProcessDesing, setSelectedProcessDesing] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const [designSelected, setDesignSelected] = useState(null);

  const handleOk = () => {
    handleVisible(false);
    setLink(designSelected);
  };

  const handleCancel = () => {
    handleVisible(false);
  };

  const { getDesignsArticle, getOneDesingData } = useProcessDesings();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    async function fetchData() {
      if (article) {
        const newList = await getDesignsArticle(article.id_article);
        setListDesings(newList);

        if (newList && newList[0]) {
          getDataOnRow(newList[0]);
        }
      }
    }
    fetchData();
  }, [article]);

  async function getDataOnRow(row) {
    const response = await getOneDesingData(row);

    setSelectedRowKey([row.id_design]);
    setSelectedProcessDesing(row);

    setDesignSelected(response);
  }

  const columns = [
    {
      title: t("table.header.name"),
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultSortOrder: "descend",
      ...Search("name"),
    },
    {
      title: t("table.header.design_date"),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: (date) => moment(date).format("DD/MM/YYYY HH:mm:ss"),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      getDataOnRow(record);
    },
    //no existe en type: radio
    onSelectAll: (selected, selectedRows, changeRows) => {
      //console.log(selected, selectedRows, changeRows);
    },
    type: "radio",
  };

  const clickRow = (row) => {
    getDataOnRow(row);
  };

  return (
    listDesings && (
      <div>
        <Modal
          title={"Seleciona un diseño"}
          visible={visible}
          onOk={handleOk}
          onCancel={handleCancel}
          okText={t("button.modal.link")}
          cancelText={t("button.modal.cancel")}
          width="80vw"
        >
          <Row>
            <Col xl={12} lg={12} md={24}>
              <Table rowKey="id_design" data={listDesings} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
            </Col>
            <Col xl={12} lg={12} md={24}>
              <HeaderOptions>{selectedProcessDesing && selectedProcessDesing.desingName}</HeaderOptions>
              <RenderDesingProcessData selectedProcessDesing={designSelected} />
            </Col>
          </Row>
        </Modal>
      </div>
    )
  );
};

export default ModalDesingProcess;
